import React from 'react';
import { Plus } from 'lucide-react';

interface EmptyStateCardProps {
  title: string;
  description: string;
  buttonText: string;
  onButtonClick: () => void;
  buttonIcon?: React.ReactNode;
}

export const EmptyStateCard: React.FC<EmptyStateCardProps> = ({
  title,
  description,
  buttonText,
  onButtonClick,
  buttonIcon = <Plus className="w-4 h-4" />
}) => {
  return (
    <div className="bg-[rgb(45,36,36)] rounded-lg p-4">
      <div className="text-center">
        <div className="text-white font-bold mb-2 text-[14px]">
          {title}
        </div>
        <div className="text-gray-400 mb-4 leading-relaxed text-[12px]">
          {description}
        </div>
        <button 
          onClick={onButtonClick}
          className="border border-white text-white rounded-full px-6 py-2 flex items-center justify-center mx-auto space-x-2 hover:bg-white hover:text-[rgb(45,36,36)] transition-colors"
        >
          {buttonIcon}
          <span className="text-[10px]">{buttonText}</span>
        </button>
      </div>
    </div>
  );
};
